import { API_BASE_URL } from '../config/apiBaseUrl';

const CDN_PREFIX = import.meta.env.VITE_CDN as string;
const API_BASE = API_BASE_URL;

let pendingRefresh: Promise<void> | null = null;

function refreshCfCookies(): Promise<void> {
  if (!pendingRefresh) {
    pendingRefresh = fetch(`${API_BASE}/all/refresh-cf-cookies/`, {
      credentials: 'include',
    })
      .then(() => { pendingRefresh = null; })
      .catch(() => { pendingRefresh = null; });
  }
  return pendingRefresh;
}

export function installCfImageRetryHandler(): void {
  document.addEventListener(
    'error',
    (event) => {
      const img = event.target;
      if (!(img instanceof HTMLImageElement)) return;
      if (img.dataset.cfRetried) return;
      if (!CDN_PREFIX || !img.src.startsWith(CDN_PREFIX)) return;

      img.dataset.cfRetried = '1';
      refreshCfCookies().then(() => {
        const sep = img.src.includes('?') ? '&' : '?';
        img.src = `${img.src}${sep}_retry=${Date.now()}`;
      });
    },
    true, // capture phase — image errors don't bubble
  );
}
